
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom",
      function () {
        return require("private-next-pages/newsroom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom"])
      });
    }
  